import React, { memo } from 'react';

// material
import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BoxStyle = styled(Box)((props) => ({
  position: props.position || 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  zIndex: 99,
}));

// eslint-disable-next-line react/prop-types
function CircularLoading({ size, title, position }) {
  return (
    <BoxStyle className="loading" position={position}>
      <CircularProgress size={size || 60} />
      {title && <p style={{ color: '#383E80' }}>{title}</p>}
    </BoxStyle>
  );
}

export default memo(CircularLoading);
